import { render, staticRenderFns } from "./MaintainerData.vue?vue&type=template&id=2dc4868d&scoped=true&"
import script from "./MaintainerData.vue?vue&type=script&lang=js&"
export * from "./MaintainerData.vue?vue&type=script&lang=js&"
import style0 from "./MaintainerData.vue?vue&type=style&index=0&id=2dc4868d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc4868d",
  null
  
)

export default component.exports